<template>
  <base-section
  id="topic-chairs"
  >
    <v-container>
    <base-section-heading
    title="Topic Chairs"
    color="red"
    align="left"
    :toColor="true"
    >
    <br>
    <div
      v-for="topic in topics"
    >
    <v-row>
        <base-avatar-card
          :title="topic.title"
          align="left"
          horizontal
        />
      </v-row>
      <v-row>
        <v-col
          v-for="(chair, i) in topic.chairs"
          :key="i"
          cols="12"
          md="6"
        >
          <base-avatar-card
            v-bind="chair"
            align="left"
            horizontal
          />
        </v-col>
      </v-row>
    </div>
    </base-section-heading>
    </v-container>
  </base-section>
</template>

<script>
  import OrganizingCommittee from './OrganizingCommittee.vue'
  export default {
    name: 'TopicChairs',
    components: { OrganizingCommittee },

    data: () => ({
        topics: [
            {
                title: "Design and Test of the Next Generation Chips",
                chairs: [
                  {
                    title: "Daniel Tille",
                    src: require('@/images/committees/danieltille.jpg'),
                    text: 'Siemens EDA, DE',
                  },
                ],
            },
            {
                title: "Emerging Technologies Design, Test and Diagnosis",
                chairs: [
                  {
                    title: "Leticia Bolzani Pöhls",
                    src: require('@/images/committees/leticiabolzani.jpg'),
                    text: 'IHP - Leibniz Institute for High Performance Microelectronics, DE',
                  },
                ],
            },
            {
                title: "Analog Circuit Design and Diagnosis",
                chairs: [
                  {
                    title: "Florence Azais",
                    src: require('@/images/committees/florenceazais.jpg'),
                    text: 'LIRMM, FR',
                  },
                ],
            },
            {
                title: "Security challenges in quantum and post-quantum era",
                chairs: [
                  {
                    title: "Mirjana Stojilovic",
                    src: require('@/images/committees/mirjana.jpg'),
                    text: 'EPFL, CH',
                  },
                ],
            },
        ],
    }),
  }
</script>

<style>
.v-application .grey--text.text--darken-1 {
  color: black !important;
}
.v-application .grey--text.text--lighten-1 {
  color: white !important;
}
</style>
